module.exports = __webpack_public_path__ + "static/media/PilatusPC12.635e36d6.png";